// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hh","advertCardFooter__row":"c-a_hi","advertCardFooter__name":"c-a_hj","advertCardFooter__price":"c-a_hk","advertCardFooter__age":"c-a_hl"};